<template>

    <footer class="c-p_footer">
        <div class="c-p_footer__container">
            <div class="c-p_footer__col">
                <h2 class="c-p_footer__title">Portal</h2>
                <p class="c-p_footer__content">
                    Sprawdź nasz portal<br>
                    <a class="c-p_footer__link" href="http://www.sprawdzonyfizjoterapeuta.pl" target="_blank">www.sprawdzonyfizjoterapeuta.pl</a>
                </p>
            </div>
            <div class="c-p_footer__col">
                <h2 class="c-p_footer__title">Kontakt</h2>
                <p class="c-p_footer__content">
                    Proven Medic sp. z o.o.<br>
                    ul. Staromiejska 17<br>
                    40-013 Katowice
                </p>
            </div>
            <div class="c-p_footer__col">
                <h2 class="c-p_footer__title">Polityka prywatności</h2>
                <p class="c-p_footer__content">
                    Przeczytaj <a class="c-p_footer__link"
                                  href="/assets/polityka_prywatnosci.pdf"
                                  target="_blank">Politykę prywatności</a><br>
                    Przeczytaj <a class="c-p_footer__link" href="/assets/regulamin_edf.pdf" target="_blank">Regulamin
                    korzystania z serwisu</a>
                </p>
            </div>
            <div class="c-p_footer__col c-p_footer__col--pull-right">
                <ul class="c-p_footer__socials">
                    <li class="c-p_footer__socials-item">
                        <a class="c-p_footer__socials-link c-p_footer__socials-link--fb"
                           href="https://www.facebook.com/Sprawdzony-Fizjoterapeuta-2235941420025183/"
                           target="_blank"></a>
                    </li>
                </ul>
            </div>
        </div>
    </footer>

</template>


<script>

export default {

    name: 'ThePublicFooter'

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-p_footer {
    margin-right: auto;
    width: 100%;
    background-color: $c-primary;
    padding: 4rem .7rem 1rem .7rem;
    color: $c-white;

    @include bp($screen-sm) {
        padding: 3rem 1rem 0 1rem;
        text-align: center;
    }
    &__container {
        display: flex;
        flex-wrap: wrap;
    }
    &__col {
        margin-bottom: 3rem;
        padding: 0 3rem;

        @include bp($screen-xl) {
            padding: 0 2rem;
        }
        @include bp($screen-lg) {
            width: 50%;
        }
        @include bp($screen-sm) {
            padding: 0;
            width: 100%;
        }
        &--pull-right {
            margin-left: auto;
        }
    }
    &__title {
        color: $c-white;
        font-size: .8rem;
        letter-spacing: 0.08rem;
        font-weight: bold;
        text-transform: uppercase;
        margin-bottom: 1.4rem;
    }
    &__link {
        color: $c-white;
        text-decoration: underline;

        &:hover {
            color: $c-white;
            text-decoration: underline;
        }
    }
    &__socials {
        width: 100%;
        margin: 0;

        &-item {
            display: inline-block;
            margin-left: 1.4rem;

            &:first-of-type {
                margin-left: 0px;
            }
        }
        &-link {
            display: block;
            width: 1rem;
            height: 1rem;
            background-position: center;
            background-repeat: no-repeat;
            background-size: contain;

            &--insta {
                background-image: url('#{$icons}/instagram.svg');
            }
            &--twitter {
                background-image: url('#{$icons}/twitter.svg');
            }
            &--fb {
                background-image: url('#{$icons}/facebook.svg');
            }
        }
    }
}

</style>
